// ─────────────────────────────────────────────────────────────────────
// A BIGGER TAP TARGET THAT MOVES NOTHING (#1144, WCAG 2.2 SC 2.5.8).
//
// Small text controls (a 15 px club strip, a 14 px «Åpne pad» link) are
// below the 24×24 px minimum, and padding them would change the layout the
// product chose. Instead the control gets an invisible, absolutely positioned
// `::before`, centred on it and at least N px square. An absolutely
// positioned box takes no space, so nothing around the control moves, and a
// tap on a pseudo-element is a tap on its element.
//
// Two sizes, by surface (decision on #1144, 2026-10-31):
//   HIT_AREA_24  the WCAG 2.2 AA minimum, for the club portal (Sentralen),
//                where controls sit close together;
//   HIT_AREA_44  for touch surfaces (the member app, Banepad dialogs).
//
// The control must not clip its overflow (no `overflow-hidden`), or the
// extension is cut off with it.
// ─────────────────────────────────────────────────────────────────────

const BASE =
  "relative before:absolute before:content-[''] before:left-1/2 before:top-1/2 " +
  'before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full';

export const HIT_AREA_24 = `${BASE} before:min-w-[24px] before:min-h-[24px]`;
export const HIT_AREA_44 = `${BASE} before:min-w-[44px] before:min-h-[44px]`;
